import React from "react";
import { generateExplanationPills } from "../../utils/quickSearchScoring";

/**
 * ExplanationPills - Renders score breakdown explanation pills for a game
 *
 * Props:
 * - scoreBreakdown: Object - Score breakdown with playerScore, timeScore, energyScore, familiarityScore, isGated
 * - familiarityPref: string - User's familiarity preference; pill is omitted when 'neutral' or 'any'
 * - style: Object - Optional additional styles for the container
 */
const ExplanationPills = ({ scoreBreakdown, familiarityPref, style = {} }) => {
  if (!scoreBreakdown) return null;

  const pills = generateExplanationPills(scoreBreakdown, familiarityPref);

  if (pills.length === 0) return null;

  const getPillClass = (type) => {
    switch (type) {
      case "positive":
        return "explanation-pill positive";
      case "negative":
        return "explanation-pill negative";
      case "neutral":
      default:
        return "explanation-pill neutral";
    }
  };

  return (
    <div className="explanation-pills" style={style}>
      {pills.map((pill, index) => (
        <span key={index} className={getPillClass(pill.type)}>
          {pill.text}
        </span>
      ))}
    </div>
  );
};

export default ExplanationPills;
